export default defineNuxtPlugin((nuxtApp) => {
  const store = nuxtApp.$store as any
  
  const translateFn = (key: string): string => {
    const state = store.state
    if (state && state._ && state._[state.locale] && state._[state.locale][key]) {
      return state._[state.locale][key]
    }
    return key
  }

  // Install as a global mixin
  nuxtApp.vueApp.mixin({
    data() {
      return {
        _: translateFn
      }
    }
  })
  
  // Also provide as a plugin
  return {
    provide: {
      translate: translateFn
    }
  }

})